<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <LocationInformation
          :locationCode="loc"
          :locationCoords="getPosition()"
        ></LocationInformation>
      </b-col>
      <b-col lg="6">
        <b-card class="chat">
          <div
            slot="header"
            style="display:flex; justify-content: space-between;"
          >
            <HeaderTitle title="Location Based Chat"></HeaderTitle>
          </div>
          <Chat v-if="loc" :cityId="loc" :isDirect="0"></Chat>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <ActiveBacklogCityDashboard
        v-if="city && loc"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="loc"
        :nameCity="city"
      ></ActiveBacklogCityDashboard>
      <DeliveredEquipmentCityDashboard
        v-if="city && loc"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="loc"
        :nameCity="city"
      ></DeliveredEquipmentCityDashboard>
    </b-row>
    <b-row>
      <HistoricalDataCityDashboard
        v-if="city && loc"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="loc"
        :nameCity="city"
      ></HistoricalDataCityDashboard>
      <BeyondEconomicalRepairCityDashboard
        v-if="city && loc"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="loc"
        :nameCity="city"
      ></BeyondEconomicalRepairCityDashboard>
    </b-row>
    <b-row>
      <ProofOfDeliveryCityDashboard
        v-if="city && loc"
        :lgSize="12"
        :lgOffset="0"
        :locParam="0"
        :idCity="loc"
        :nameCity="city"
      ></ProofOfDeliveryCityDashboard>
    </b-row>
  </div>
</template>

<script>
import ActiveBacklogCityDashboard from "../../../components/city-dashboard/ActiveBacklogCityDashboard";
import HistoricalDataCityDashboard from "../../../components/city-dashboard/HistoricalDataCityDashboard";
import BeyondEconomicalRepairCityDashboard from "../../../components/city-dashboard/BeyondEconomicalRepairCityDashboard";
import Chat from "../../../components/shared/Chat";
import DeliveredEquipmentCityDashboard from "../../../components/city-dashboard/DeliveredEquipmentCityDashboard";
import ProofOfDeliveryCityDashboard from "../../../components/city-dashboard/ProofOfDeliveryCityDashboard";
import LocationInformation from "../../../components/city-dashboard/LocationInformation.vue";
import router from "../../../router";
import { Chart } from "highcharts-vue";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import { isUserLoggedIn } from "../../../utils/Utils";

export default {
  name: "CityDashboard",
  props: ["loc", "city", "lat", "lng"],
  components: {
    ActiveBacklogCityDashboard,
    HistoricalDataCityDashboard,
    BeyondEconomicalRepairCityDashboard,
    DeliveredEquipmentCityDashboard,
    Chat,
    ProofOfDeliveryCityDashboard,
    LocationInformation,
    highcharts: Chart,
    HeaderTitle
  },
  data: function() {
    return {};
  },
  methods: {
    getPosition: function() {
      return {
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng)
      };
    }
  },
  mounted() {
    isUserLoggedIn(router);
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
</style>
